// @flow
import React from 'react'

const ArrowUp = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7">
      <g fill="none" fillRule="evenodd">
        <path d="M-2-5h16v16H-2z" />
        <path
          stroke="#4A5665"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M1.5 6L6 1.5 10.5 6"
        />
      </g>
    </svg>
  )
}

export default ArrowUp



// WEBPACK FOOTER //
// ./src/components/Icons/ArrowUp.js